import React from 'react';
import { TagTable } from '@tag/tag-components-react-v2';

export type MethodTableColumns = {
  name: string;
  description: string;
  parameters: string;
  returnType: string;
};
export type Props = {
  data: MethodTableColumns[];
};
export const ComponentMethods: React.FC<Props> = ({ data }) => {
  return (
    <div>
      <TagTable
        columns={[
          {
            name: 'name',
            caption: 'Name',
          },
          {
            name: 'description',
            caption: 'Description',
          },
          {
            name: 'parameters',
            caption: 'Parameters',
          },
          {
            name: 'returnType',
            caption: 'Return Type',
          },
        ]}
        data={data}
      />
    </div>
  );
};
